import { useUser } from "@/context/user-context";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import RunButton from "../../../ui/RunButton";
import { usePlayground } from "../../playground-store";
import { PlaygroundDialogType } from "../../PlaygroundDialog/constants";
import { PlaygroundDialogStoreContext } from "../../PlaygroundDialog/playground-dialog-store";
import SaveTemplateDialog from "./SaveTemplateDialog";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { DocumentTextIcon } from "@heroicons/react/outline";
import { Button } from "@/components/ui/button";

const ControlBar = () => {
  const playground = usePlayground();
  const playgroundDialogStore = useContext(PlaygroundDialogStoreContext);
  const user = useUser();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleRun = async () => {
    if (
      playground.input_variables.length === 0 &&
      playgroundDialogStore &&
      !localStorage.getItem("showInputVariablesTutorial") &&
      user.isNewUser
    ) {
      playgroundDialogStore.setIsDialogOpen({
        isOpen: true,
        dialogType: PlaygroundDialogType.NoInputVariables,
      });
      return;
    }

    if (!executeRecaptcha) {
      console.error("Execute recaptcha not available");
      return;
    }

    const recaptcha_response = await executeRecaptcha("playground");

    playground.run(recaptcha_response);
  };

  return (
    <>
      <div className="relative mx-auto mb-3 h-[65px] w-full border-b">
        <div className="flex flex-row justify-between p-3">
          {/* <div className="flex flex-row gap-x-1">
            <Button variant="default" className="whitespace-nowrap">
              Ad-Hoc
            </Button>
            <Button variant="outline">Eval</Button>
          </div> */}

          <div className="flex w-full flex-row items-center justify-between gap-x-3">
            <Button
              variant="ghost"
              size="sm"
              className="flex items-center gap-2 text-gray-500 hover:text-gray-700"
              onClick={() =>
                window.open("https://docs.promptlayer.com/", "_blank")
              }
            >
              <DocumentTextIcon className="h-4 w-4" />
              <span className="text-sm">Docs</span>
            </Button>

            <div className="flex flex-row items-center gap-x-3">
              <SaveTemplateDialog
                disabled={
                  playground.isSavingSession ||
                  playground.isAIPromptAssistantLoading
                }
                size="default"
              />
              <RunButton
                cancel={playground.cancel}
                run={handleRun}
                disabled={playground.isAIPromptAssistantLoading}
                disabledTooltip="Save your template first before running"
                isRunning={playground.operationStore.isRunning}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(ControlBar);
